export const COHORTS_EVENT_DATA_FIELD_KEYS = {
  INSTALL: 'install',
  OPEN: 'open',
  PAGEVIEW: 'pageview',
  REINSTALL: 'reinstall',
  WEB_SESSION_START: 'web_session_start',

  PURCHASE: 'purchase',
  ADD_TO_CART: 'add_to_cart',
  ADD_TO_WISHLIST: 'add_to_wishlist',
  VIEW_CART: 'view_cart',
  INITIATE_PURCHASE: 'initiate_purchase',
  ADD_PAYMENT_INFO: 'add_payment_info',
  SPEND_CREDITS: 'spend_credits',
  RESERVE: 'reserve',
  CLICK_AD: 'click_ad',
  VIEW_AD: 'view_ad',

  SEARCH: 'search',
  VIEW_ITEM: 'view_item',
  VIEW_ITEMS: 'view_items',
  RATE: 'rate',
  SHARE: 'share',
  INITIATE_STREAM: 'initiate_stream',
  COMPLETE_STREAM: 'complete_stream',

  COMPLETE_REGISTRATION: 'complete_registration',
  COMPLETE_TUTORIAL: 'complete_tutorial',
  ACHIEVE_LEVEL: 'achieve_level',
  UNLOCK_ACHIEVEMENT: 'unlock_achievement',
  INVITE: 'invite',
  LOGIN: 'login',
  SUBSCRIBE: 'subscribe',
  START_TRIAL: 'start_trial',
  OPT_IN: 'opt_in',
  OPT_OUT: 'opt_out',
} as const;

export const COHORTS_METRIC_DATA_FIELD_KEYS = {
  REVENUE: 'revenue',
  USERS: 'users',
  COST: 'cost',
} as const;

export const COHORTS_CALCULATION_DATA_FIELD_KEYS = {
  ARPU: 'arpu',
  ARPPU: 'arppu',
  LTV: 'ltv',
  ECPA: 'ecpa',
  GROSS_PROFIT: 'gross_profit',
  RETENTION: 'retention',
  ROAS: 'roas',
  ROI: 'roi',
} as const;

export const COHORTS_DATA_FIELD_KEYS = {
  ...COHORTS_EVENT_DATA_FIELD_KEYS,
  ...COHORTS_METRIC_DATA_FIELD_KEYS,
  ...COHORTS_CALCULATION_DATA_FIELD_KEYS,
} as const;
